module.exports = __webpack_public_path__ + "img/stock7.058505e8.png";